import React, { useEffect, useState } from "react";
import { Input, Select, Button, Form, DatePicker, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { createInventory, updateInventory } from "../../../../Store/Slices/Finance/inventory/inventory.thunk";
import FinanceCategorySelect from "../financeCategory/FinanceCategorySelect";
import dayjs from "dayjs";
import EntitySelect from "../entities/EntitySelect";
import { BsInfoCircle } from "react-icons/bs";
import { useTranslation } from "react-i18next";


const InventoryForm = ({ visible, onClose, editData }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const { t } = useTranslation("prtFinance");
  const { loading } = useSelector(
    (store) => store.admin.inventory
  );
  let viewMode = false;
  if (editData?.mode == "view") {
    viewMode = true
  }
  useEffect(() => {
    if (editData) {
      if (editData?.mode == "view") {

      }
      form.setFieldsValue({
        ...editData,
        orderDate: editData.orderDate ? dayjs(editData.orderDate) : null,
        deliveryDate: editData.deliveryDate ? dayjs(editData.deliveryDate) : null,
        expireDate: editData?.expireDate ? dayjs(editData.expireDate) : null,
      });
      setSelectedCategory({ _id: editData.categoryId, categoryName: editData.categoryName });
      setSelectedEntity({ _id: editData.supplierId._id });
    } else {
      form.resetFields();
      setSelectedCategory(null);
    }


  }, [editData, onClose]);

  const handleSubmit = async (values) => {

    const payload = {
      ...values,
      categoryId: selectedCategory?._id,
      categoryName: selectedCategory?.categoryName,
      supplierId: selectedEntity?._id, // Ensure supplierId is included
    };

    if (editData) {
      await dispatch(updateInventory({ id: editData._id, ...payload })).then((res) => {
        if (res?.payload?.success) {
          onClose();
        }
      });
    } else {
      await dispatch(createInventory(payload)).then((res) => {
        if (res?.payload?.success) {
          onClose();
        }
      });
    }
  };


  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="itemName" label={t("Item Name")} rules={[{ required: true, message: t("Please enter item name") }]}>
          <Input placeholder={t("Enter item name")} disabled={viewMode} />
        </Form.Item>
        <Form.Item name="SKU" label={t("SKU")} >
          <Input placeholder={t("Enter SKU")} disabled={viewMode} />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="quantity" label={t("Quantity")} rules={[{ required: true, message: t("Please enter quantity") }]}>
          <Input type="number" placeholder={t("Enter quantity")} disabled={viewMode} />
        </Form.Item>
        <Form.Item name="unit" label={t("Unit")} rules={[{ required: true, message: t("Please enter unit") }]}>
          <Input placeholder={t("Enter unit")} disabled={viewMode} />
        </Form.Item>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="unitPrice" label={t("Unit Price")} rules={[{ required: true, message: t("Please enter unit price") }]}>
          <Input type="number" placeholder={t("Enter unit price")} disabled={viewMode} />
        </Form.Item>
        <Form.Item name="lowStockAlert" label={t("Low Stock Alert")}>
          <Select
            placeholder={t("Set Low Stock Alert")}
            disabled={viewMode}
            className="w-full"
          >
            {/* Use boolean values directly here */}
            <Select.Option value={true}>{t("Yes")}</Select.Option>
            <Select.Option value={false}>{t("No")}</Select.Option>
          </Select>
        </Form.Item>

      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          label={
            <span className="flex items-center gap-1">
              <span className="font-medium"><span className='text-red-400 text-lg'>* </span>{t("Category")}</span>
              <Tooltip
                title={
                  <>
                    <div className="text-xs">{t("All Asset, Expense, and Revenue categories appear here.")}
                      {t("Use this to log stock items — whether they are durable assets, consumable supplies, or items meant for resale like uniforms and books.")} </div>

                  </>
                }
              >
                <BsInfoCircle className="cursor-pointer" />
              </Tooltip>
            </span>
          }
          rules={[{ required: true, message: t("Please select Category") }]}>
          <FinanceCategorySelect categoryType="" onSelect={setSelectedCategory} disabled={viewMode} categoryName={editData?.categoryName} onClose={onClose} />
        </Form.Item>
        <Form.Item name="supplierId" label={t("Supplier")} rules={[{ required: true, message: t("Please Select Supplier") }]}>
          <EntitySelect onClose={onClose} onSelect={(entity) => {
            setSelectedEntity(entity);
            form.setFieldsValue({ supplierId: entity._id });
          }} disabled={viewMode} EntityName={editData?.supplierId.entityName} />
        </Form.Item>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="damagedQuantity" label={t("Damaged Quantity")} >
          <Input type="number" placeholder={t("Damaged Quantity")} disabled={viewMode} />
        </Form.Item>
        <Form.Item name="lowStockNumber" label={t("Low Stock Number")} rules={[{ required: true, message: t("Please enter low Stock Number") }]}>
          <Input type="number" placeholder={t("Enter Low Stock Number")} disabled={viewMode} />
        </Form.Item>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <Form.Item name="orderDate" label={t("Order Date")} rules={[{ required: true, message: t("Please enter Order Date") }]}>
          <DatePicker className="w-full" disabled={viewMode} />
        </Form.Item>
        <Form.Item name="deliveryDate" label={t("Delivery Date")} rules={[{ required: true, message: t("Please enter Order Date") }]}>
          <DatePicker className="w-full" disabled={viewMode} />
        </Form.Item>
        <Form.Item name="expireDate" label={t("Expiry Date")} >
          <DatePicker className="w-full" disabled={viewMode} />
        </Form.Item>
      </div>

      {
        !viewMode &&
        <button disabled={viewMode || loading} className="btn-gradient flex items-center justify-center text-white w-full py-2" htmlType="submit">
          {editData ? loading ? t("Updating...") : t("Update Inventory")
            : loading ? t("Adding...") : t("Add Inventory")}
        </button>
      }
    </Form>
  );
};

export default InventoryForm;
